/* Joyeux Marché — animations et messages datés. Sans dépendance. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* Date de Paris (+ simulateur ?jm_date= hors thème en ligne) */
  function parisNow() {
    var sim = null;
    try {
      var isPreview = (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') || (window.Shopify && Shopify.designMode);
      if (isPreview) sim = new URLSearchParams(location.search).get('jm_date');
      if (isPreview && sim) sset('jm_date', sim); else if (isPreview) sim = sget('jm_date');
    } catch (e) {}
    if (sim && /^\d{4}-\d{2}-\d{2}$/.test(sim)) return { y: +sim.slice(0, 4), m: +sim.slice(5, 7), d: +sim.slice(8, 10), h: 12, sim: true };
    var parts = {};
    try {
      new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24 };
    } catch (e) { var n = new Date(); return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() }; }
  }
  var NOW = parisNow();
  function key(y, m, dd) { return y * 10000 + m * 100 + dd; }
  var TODAY = key(NOW.y, NOW.m, NOW.d);
  window.JM = { now: NOW, today: TODAY };

  /* Préférences animations */
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return mq.matches || get('jm_motion') === 'reduced'; }
  function snowOn() { return !reduced() && get('jm_snow') !== 'off'; }
  function applyClasses() {
    root.classList.toggle('jm-reduced', reduced());
    root.classList.toggle('jm-snow-off', !snowOn());
  }
  applyClasses();

  /* Neige (canvas) */
  var snow = { cv: null, ctx: null, flakes: [], raf: 0, running: false, w: 0, h: 0, dpr: 1 };
  function snowInit() {
    if (snow.cv) return;
    var cv = d.createElement('canvas');
    cv.className = 'jm-snow'; cv.setAttribute('aria-hidden', 'true');
    d.body.appendChild(cv);
    snow.cv = cv; snow.ctx = cv.getContext('2d');
    resize(); addEventListener('resize', resize, { passive: true });
  }
  function resize() {
    if (!snow.cv) return;
    snow.dpr = Math.min(window.devicePixelRatio || 1, 2);
    snow.w = innerWidth; snow.h = innerHeight;
    snow.cv.width = snow.w * snow.dpr; snow.cv.height = snow.h * snow.dpr;
    snow.ctx.setTransform(snow.dpr, 0, 0, snow.dpr, 0, 0);
    var n = snow.w < 750 ? 40 : 80;
    snow.flakes = [];
    for (var i = 0; i < n; i++) snow.flakes.push(flake(true));
  }
  function flake(any) {
    return { x: Math.random() * snow.w, y: any ? Math.random() * snow.h : -10, r: 1 + Math.random() * 2.6, s: 0.35 + Math.random() * 0.9, o: Math.random() * Math.PI * 2, a: 0.5 + Math.random() * 0.45 };
  }
  var wind = 0, windT = 0;
  function frame(t) {
    var c = snow.ctx; c.clearRect(0, 0, snow.w, snow.h);
    c.strokeStyle = 'rgba(110,130,150,.35)'; c.lineWidth = .6;
    if (t - windT > 4000) { windT = t; wind = (Math.random() - 0.5) * 0.6; }
    for (var i = 0; i < snow.flakes.length; i++) {
      var f = snow.flakes[i];
      f.o += 0.01; f.y += f.s; f.x += Math.sin(f.o) * 0.35 + wind;
      if (f.y > snow.h + 5 || f.x < -10 || f.x > snow.w + 10) snow.flakes[i] = flake(false);
      c.beginPath(); c.fillStyle = 'rgba(255,255,255,' + f.a + ')'; c.arc(f.x, f.y, f.r, 0, 6.283); c.fill(); c.stroke();
    }
    snow.raf = requestAnimationFrame(frame);
  }
  function snowStart() { if (!snowOn() || d.hidden) return; snowInit(); if (!snow.running) { snow.running = true; snow.raf = requestAnimationFrame(frame); } }
  function snowStop() { snow.running = false; cancelAnimationFrame(snow.raf); if (snow.ctx) snow.ctx.clearRect(0, 0, snow.w, snow.h); }
  d.addEventListener('visibilitychange', function () { d.hidden ? snowStop() : snowStart(); });

  /* Boutons neige / animations + lien Gérer les cookies */
  function syncButtons() {
    d.querySelectorAll('[data-jm-snow-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(snowOn()));
      var l = b.querySelector('[data-label]'); if (l) l.textContent = snowOn() ? 'Neige : on' : 'Neige : off';
    });
    d.querySelectorAll('[data-jm-motion-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(!reduced()));
      var l = b.querySelector('[data-label]'); if (l) l.textContent = reduced() ? 'Animations : réduites' : 'Animations : complètes';
    });
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-jm-snow-toggle],[data-jm-motion-toggle],a[href$="#gerer-les-cookies"]') : null;
    if (!t) return;
    if (t.matches('a[href$="#gerer-les-cookies"]')) {
      e.preventDefault();
      try { if (window.privacyBanner && privacyBanner.showPreferences) privacyBanner.showPreferences(); } catch (er) {}
      return;
    }
    if (t.hasAttribute('data-jm-snow-toggle')) set('jm_snow', snowOn() ? 'off' : 'on');
    else set('jm_motion', reduced() ? 'full' : 'reduced');
    applyClasses(); syncButtons(); snowOn() ? snowStart() : snowStop();
  });
  if (mq.addEventListener) mq.addEventListener('change', function () { applyClasses(); syncButtons(); snowOn() ? snowStart() : snowStop(); });

  /* Messages datés */
  function between(a, b) { return TODAY >= a && TODAY <= b; }
  function datedBlocks() {
    d.querySelectorAll('[data-jm-from],[data-jm-to]').forEach(function (el) {
      var f = +(el.getAttribute('data-jm-from') || '0').replace(/-/g, '');
      var to = +(el.getAttribute('data-jm-to') || '99999999').replace(/-/g, '');
      el.hidden = !between(f, to);
    });
    d.querySelectorAll('[data-jm-now-from]').forEach(function (li) {
      var a = +li.getAttribute('data-jm-now-from'), b = +li.getAttribute('data-jm-now-to');
      if (between(a, b)) { li.classList.add('is-now'); li.setAttribute('aria-current', 'date'); }
    });
    var y = NOW.y;
    var msg;
    if (between(key(y, 11, 23), key(y, 11, 30))) msg = 'Black Friday (la semaine des bonnes affaires) : 2 articles achetés, le 3e offert, jusqu\'au lundi 30 novembre à 23 h 59';
    else if (TODAY <= key(y, 11, 29) && NOW.m >= 10) msg = 'Pour être livré avant Noël, commande avant le 30 novembre · Livraison offerte dès 65 €';
    else if (between(key(y, 12, 1), key(y, 12, 11))) msg = 'Livraison avant Noël encore possible, mais pas garantie : délais indicatifs de 8 à 18 jours ouvrés';
    else if (between(key(y, 12, 12), key(y, 12, 24))) msg = 'Ta commande arrivera sans doute après Noël. La carte cadeau, elle, arrive tout de suite par e-mail';
    else if (between(key(y, 12, 25), key(y, 12, 31))) msg = 'Joyeuses fêtes !';
    if (msg) d.querySelectorAll('[data-jm-announce]').forEach(function (el) { el.textContent = msg; });
    if (between(key(y, 11, 23), key(y, 11, 30))) root.classList.add('jm-bf');
  }

  /* Jours ouvrés et estimation de livraison */
  var HOL = { '11-11': 1, '12-25': 1, '1-1': 1, '5-1': 1, '5-8': 1, '7-14': 1, '8-15': 1, '11-1': 1 };
  function addWorkdays(date, n) {
    var x = new Date(date.getTime());
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      var wd = x.getDay(), k = (x.getMonth() + 1) + '-' + x.getDate();
      if (wd !== 0 && wd !== 6 && !HOL[k]) n--;
    }
    return x;
  }
  var fmt = function (x) { try { return x.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return x.toDateString(); } };
  function deliveryEstimate() {
    var els = d.querySelectorAll('[data-jm-delivery]'); if (!els.length) return;
    var base = new Date(NOW.y, NOW.m - 1, NOW.d);
    var a = addWorkdays(base, 8), b = addWorkdays(base, 18);
    els.forEach(function (el) { el.textContent = 'Livraison estimée entre le ' + fmt(a) + ' et le ' + fmt(b) + ' (délais indicatifs)'; });
  }

  /* Compte à rebours Noël */
  function countdown() {
    var els = d.querySelectorAll('[data-jm-countdown]'); if (!els.length) return;
    var xmas = new Date(NOW.y, 11, 25), today = new Date(NOW.y, NOW.m - 1, NOW.d);
    var days = Math.round((xmas - today) / 864e5);
    els.forEach(function (el) {
      var txt = days > 1 ? 'Noël dans ' + days + ' jours' : days === 1 ? 'Noël, c\'est demain !' : days === 0 ? 'Joyeux Noël !' : 'Joyeuses fêtes !';
      var n = el.querySelector('[data-num]');
      if (n && days > 0) { n.textContent = days; el.setAttribute('aria-label', txt); } else el.textContent = txt;
    });
  }

  /* Ciel du hero selon l'heure */
  function sky() {
    var h = NOW.h, s = h >= 8 && h < 16 ? 'day' : (h >= 16 && h < 18) || (h >= 7 && h < 8) ? 'dusk' : 'night';
    d.querySelectorAll('[data-jm-sky]').forEach(function (el) { el.setAttribute('data-jm-sky', s); });
  }

  /* Apparition au défilement */
  function reveal() {
    var els = d.querySelectorAll('.jm-reveal'); if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduced()) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e, i) { e.style.setProperty('--jm-delay', (i % 6) * 60 + 'ms'); io.observe(e); });
  }

  /* Traîneau (une fois par visite) */
  function sleigh() {
    var s = d.querySelector('.jm-sleigh'); if (!s) return;
    if (reduced() || sget('jm_sleigh')) return;
    sset('jm_sleigh', '1');
    setTimeout(function () { s.classList.add('is-flying'); }, 1200);
  }

  /* Bandeau défilant : bouton pause */
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-jm-marquee-toggle]') : null; if (!b) return;
    var m = b.closest('.jm-marquee'); var p = m.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', String(p)); b.textContent = p ? 'Lecture' : 'Pause';
  });

  /* Barre livraison offerte (traîneau) */
  var THRESHOLD = 6500;
  function freeShip(total) {
    d.querySelectorAll('[data-jm-freeship]').forEach(function (el) {
      var t = typeof total === 'number' ? total : +el.getAttribute('data-total') || 0;
      var pct = Math.min(100, Math.round(t / THRESHOLD * 100));
      el.style.setProperty('--jm-progress', pct + '%');
      var txt = el.querySelector('[data-text]');
      var left = Math.max(0, THRESHOLD - t);
      if (txt) txt.textContent = left > 0 ? 'Plus que ' + (left / 100).toFixed(2).replace('.', ',') + ' € pour la livraison offerte' : 'Livraison offerte en France 🎉';
      if (left === 0) el.classList.add('is-done'); else el.classList.remove('is-done');
    });
  }
  function refreshCart() {
    if (!d.querySelector('[data-jm-freeship]')) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { freeShip(c.total_price); }).catch(function () {});
  }
  d.addEventListener('cart:update', refreshCart);
  d.addEventListener('cart:updated', refreshCart);

  /* Ajout au panier : paquet cadeau */
  d.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var b = f.querySelector('[type="submit"]'); if (!b || reduced()) return;
    b.classList.add('jm-gift-pop'); setTimeout(function () { b.classList.remove('jm-gift-pop'); refreshCart(); }, 1200);
  }, true);

  function init() {
    datedBlocks(); deliveryEstimate(); countdown(); sky(); reveal(); sleigh(); syncButtons(); refreshCart();
    snowStart();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
